import formatName from 'I18n/utils/formatName';
import I18n from 'I18n';
import Loadable from 'UIComponents/decorators/Loadable';
import UILink from 'UIComponents/link/UILink';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import { H5 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UISimpleAvatar = Loadable({
  loader: () =>
  // @ts-expect-error Library not yet migrated
  import( /* webpackChunkName: "bundles/avatars" */'ui-addon-avatars').then(mod => mod.UIAvatar)
});
const socialMediaNamesMap = {
  x: 'X',
  linkedin: 'LinkedIn'
};
const BASE_CLASS_NAME = 'professor-row';
const SocialLink = ({
  type,
  url
}) => {
  return url ? /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: url,
      children: socialMediaNamesMap[type]
    })
  }) : null;
};
const ProfessorRow = ({
  id,
  name,
  description,
  image,
  xUrl,
  linkedinUrl,
  jobTitle,
  organisation,
  organisationUrl,
  handleOrganisationUrlClick
}) => {
  return /*#__PURE__*/_jsxs(UIMedia, {
    className: BASE_CLASS_NAME,
    children: [/*#__PURE__*/_jsx(UIMediaLeft, {
      children: /*#__PURE__*/_jsx(UISimpleAvatar, {
        alt: I18n.text('learningCenter.lessonInformation.professorPictureAltText', {
          name: formatName({
            name
          })
        }),
        className: `${BASE_CLASS_NAME}__picture`,
        shape: "circle",
        size: "lg",
        src: image
      })
    }), /*#__PURE__*/_jsxs(UIMediaBody, {
      className: `${BASE_CLASS_NAME}__name-header`,
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-bottom-0",
        children: name
      }), /*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: jobTitle
      }), /*#__PURE__*/_jsx("p", {
        children: organisationUrl && organisation ? /*#__PURE__*/_jsx(UILink, {
          external: true,
          href: organisationUrl,
          onClick: handleOrganisationUrlClick(id, organisation, organisationUrl),
          children: organisation
        }) : organisation
      }), /*#__PURE__*/_jsx("p", {
        children: description
      }), /*#__PURE__*/_jsx(SocialLink, {
        type: "x",
        url: xUrl
      }), /*#__PURE__*/_jsx(SocialLink, {
        type: "linkedin",
        url: linkedinUrl
      })]
    })]
  });
};
export default ProfessorRow;